"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportBookmarkInfoCore = void 0;
var ImportBookmarkInfoCore = (function () {
    function ImportBookmarkInfoCore() {
        this.start = -1;
        this.end = -1;
    }
    ImportBookmarkInfoCore.prototype.validate = function (subDocument) {
        if (this.start < 0 || this.end < 0)
            return false;
        if (this.start > this.end) {
            var temp = this.start;
            this.start = this.end;
            this.end = temp;
        }
        var maxPosition = subDocument.getDocumentEndPosition() + 1;
        if (this.start > maxPosition)
            this.start = maxPosition;
        if (this.end > maxPosition)
            this.end = maxPosition;
        return true;
    };
    return ImportBookmarkInfoCore;
}());
exports.ImportBookmarkInfoCore = ImportBookmarkInfoCore;
